import { Configuration } from '../../api-client';
import { IAM_API_ENDPOINT } from '../config/config';
import { isReverseProxyDisabled } from '../utils/common';

export const getApiConfiguration = (): Configuration => {
  const basePath = isReverseProxyDisabled() ? IAM_API_ENDPOINT : '/iam';
  return new Configuration({ basePath });
};
